import { ROUTES } from '../consts/general';

// The Eadin iPad app loads these hosted pages in its own web view, where
// Capacitor's bridge is present. The bundled RFID screen lives at the
// app's local origin.
export const APP_RFID_URL = 'capacitor://localhost/';
const LAST_PAGE_KEY = 'eadinAppPage';

export const APP_MENU_ITEMS = [
  { id: 'transfer', label: 'Inventory Transfer', subtitle: 'Move stock between locations', path: ROUTES.INVENTORY_TRANSFERS },
  { id: 'receiving', label: 'Receiving', subtitle: 'Count and receive a PO', path: ROUTES.RECEIVED_SESSIONS },
  { id: 'rfid', label: 'RFID Receiving', subtitle: 'Scan a box with the RFD90', path: null },
];

export const APP_PATHS = APP_MENU_ITEMS.map((item) => item.path).filter(Boolean);

export function isInEadinApp(win = typeof window === 'undefined' ? undefined : window) {
  try {
    return win?.Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

export function rememberAppPage(pathname, storage = window.sessionStorage) {
  if (APP_PATHS.includes(pathname)) storage.setItem(LAST_PAGE_KEY, pathname);
}

export function appHomePath(storage = window.sessionStorage) {
  const last = storage.getItem(LAST_PAGE_KEY);
  return APP_PATHS.includes(last) ? last : ROUTES.RECEIVED_SESSIONS;
}

export function leaveForRfid(win = window) {
  win.location.assign(APP_RFID_URL);
}
